
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import firebaseConfig from './firebaseConfig';

firebase.initializeApp(firebaseConfig);


const settings = {/* your settings... */};

firebase.firestore().settings(settings);

export default firebase
  

